import { RepositoryFactory } from "@/Apicall/RepositoryFactory";
const admin = RepositoryFactory.get("admin");
const events = RepositoryFactory.get("events");

export default {
  UserLogin({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await admin.userLogin(payload);

        localStorage.setItem("token", data.data.token);
        commit("USER_LOGIN", { key: "login", value: data.data });

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  createNewPassword({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await admin.createNewPassword(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  addUserAsAdmin({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await admin.addUserAsAdmin(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  editUserAsAdmin({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await admin.editUserAsAdmin(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getRoles({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await admin.getRoles(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  addRole({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const data = await admin.addRole(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  removeRole({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const data = await admin.removeRole(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getAdmins({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const data = await admin.getAdmins(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  deleteAdmins({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const data = await admin.deleteAdmins(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  addAdmin({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const data = await admin.addAdmin(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getEvents({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const data = await events.getEvents(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  SendEmail({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const data = await admin.EmailSend(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  sendOTP({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const data = await admin.sendOTP(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  confirmOTP({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const data = await admin.confirmOTP(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  contactUsData({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const data = await admin.contactUsData(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
